import { useEffect, useState } from 'react';
import { useStreamContext } from '../../../stream/context';
import { streamStorage$ } from '../../../stream/streamStorage';
const useContextOrStorage = (formName)=>{
    // stream context must be called every time, otherwise it will break rule of hooks
    const streamContext = useStreamContext();
    const [storageStream, setStorageStream] = useState({});
    useEffect(()=>{
        if (formName) {
            const sub = streamStorage$.subscribe((streamStorage)=>{
                setStorageStream(streamStorage[formName] || {});
            });
            return ()=>{
                sub.unsubscribe();
            };
        }
    }, [
        formName
    ]);
    return formName ? storageStream : streamContext;
};
export default useContextOrStorage;
